import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { CHECKOUT_STEP_MAP, SHIP_OPTIONS_STEP } from 'constants/checkoutFlow';
import { DIGITAL_DELIVERY_ONLY_MESSAGE } from 'constants/siteMessages';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import RightArrow from 'components/checkout/caap/RightArrow';
import { formatPrice } from 'containers/Checkout/ShipOptionsSection';
import css from 'styles/components/checkout/melody/shipoption/purchaseShippingOption.scss';

const PurchaseShippingOption = ({ deliveryPromise, hasDigitalDelivery, hasRetailDelivery, onChangeAddressClick, promise, purchaseId, shippingCharge, showChangeLink }, { testId }) => {
  const mobileContent = <Row>
    <RowSpan span="10">
      { hasRetailDelivery && makePhysicalShipping({ promise, shippingCharge, deliveryPromise }) }
      { hasRetailDelivery && hasDigitalDelivery && <div className={css.separator}></div> }
      { hasDigitalDelivery && makeDigitalShipping() }
      { !hasRetailDelivery && !hasDigitalDelivery && <div>No ship options available. More information provided below in the review order section.</div> }
    </RowSpan>
    <RowSpan span="2">
      {
        (hasRetailDelivery || hasDigitalDelivery) && showChangeLink && <RightArrow />
      }
    </RowSpan>
  </Row>;

  return (
    <>
      <Row desktopOnly={true}>
        <RowSpan span="4">
          <div className={css.inactiveTitleBar}>
            <div className={css.titleWrapper}>
              <div className={css.stepIndex}>
                <h3>3</h3>
              </div>
              <h4 className={css.title}>Shipping options</h4>
            </div>
          </div>
        </RowSpan>
        <RowSpan span="6">
          { hasRetailDelivery && makePhysicalShipping({ promise, shippingCharge, deliveryPromise }) }
          { hasRetailDelivery && hasDigitalDelivery && <div className={css.separator}></div> }
          { hasDigitalDelivery && makeDigitalShipping() }
          { !hasRetailDelivery && !hasDigitalDelivery && <div>No ship options available. More information provided below in the review order section.</div> }
        </RowSpan>
        <RowSpan span="2">
          {
            (hasRetailDelivery || hasDigitalDelivery) && showChangeLink && <div className={css.changeSectionContainer}>
              <Link
                onClick={onChangeAddressClick}
                to={`${CHECKOUT_STEP_MAP[SHIP_OPTIONS_STEP]}?referrer=spc&pid=${purchaseId}`}
                data-test-id={testId('changeShipAddress')}>Change</Link>
            </div>
          }
        </RowSpan>
      </Row>

      <Row mobileOnly={true}>
        {
          (hasRetailDelivery || hasDigitalDelivery)
            ? <Link onClick={onChangeAddressClick} to={`${CHECKOUT_STEP_MAP[SHIP_OPTIONS_STEP]}?referrer=spc&pid=${purchaseId}`} data-test-id={testId('changeShipAddress')}>
              { mobileContent }
            </Link>
            : mobileContent
        }
      </Row>
    </>
  );
};

const makePhysicalShipping = ({ promise, shippingCharge, deliveryPromise }) => (
  <div>
    <div className={css.promiseLine}>
      { promise } { formatPrice(shippingCharge) }
    </div>
    { deliveryPromise && <span className={css.deliveryPromise}>{ deliveryPromise }</span> }
  </div>
);

const makeDigitalShipping = () => (
  <div>
    <strong>Digital Delivery:</strong> { DIGITAL_DELIVERY_ONLY_MESSAGE }
  </div>
);

PurchaseShippingOption.contextTypes = {
  testId: PropTypes.func
};

export default PurchaseShippingOption;
